import { useState } from 'react';

import { IProductItemViewModel } from 'Types/Litium';

import CrossIcon from 'Icons/closeThin.svg?react';

interface ProductCardColorsProps {
    colors: IProductItemViewModel['productFilters']['colors'];
}

const ProductCardColors = ({ colors }: ProductCardColorsProps) => {
    const [showAllColors, setShowAllColors] = useState(false);
    const colorLengthCriteria = 3;
    return (
        <div className="flex items-center justify-between">
            {colors?.length > 1 && (
                <ul className="flex flex-wrap gap-2">
                    {colors
                        .slice(0, colorLengthCriteria)
                        .map((color, index) => (
                            <li key={index} className="flex items-center">
                                <a
                                    href={color.url}
                                    aria-label={color.title}
                                    title={color.title}
                                    className="block h-6 w-6 rounded-full border border-solid border-gray-300"
                                    style={{
                                        backgroundColor: color.colorHex,
                                    }}
                                >
                                    {!color.enabled && (
                                        <div className="pointer-events-none absolute flex h-[22px] w-[22px] items-center justify-center">
                                            <CrossIcon
                                                className={`pointer-events-none top-0 flex h-5 w-5 ${
                                                    color.colorHex.includes(
                                                        '#f'
                                                    )
                                                        ? 'text-grey-100'
                                                        : 'text-white'
                                                }`}
                                            />
                                        </div>
                                    )}
                                </a>
                            </li>
                        ))}

                    {colors.length > colorLengthCriteria && !showAllColors && (
                        <li>
                            <button
                                className="flex h-full cursor-pointer items-center gap-0.5 pr-1"
                                onClick={() => setShowAllColors(true)}
                            >
                                <span className="font-montserrat text-h5 font-normal leading-none text-black">
                                    +
                                </span>
                                <span className="flex items-center font-roboto text-xs text-black">
                                    {colors.length - colorLengthCriteria}
                                </span>
                            </button>
                        </li>
                    )}
                    {showAllColors &&
                        colors
                            .slice(colorLengthCriteria)
                            .map((color, index) => (
                                <li
                                    key={index}
                                    className="flex animate-grow items-center"
                                >
                                    <a
                                        href={color.url}
                                        aria-label={color.title}
                                        title={color.title}
                                        className="block h-6 w-6 rounded-full border border-solid border-gray-300"
                                        style={{
                                            backgroundColor: color.colorHex,
                                        }}
                                    >
                                        {!color.enabled && (
                                            <div className="pointer-events-none absolute flex h-[22px] w-[22px] items-center justify-center">
                                                <CrossIcon
                                                    className={`pointer-events-none top-0 flex h-5 w-5 ${
                                                        color.colorHex.includes(
                                                            '#f'
                                                        )
                                                            ? 'text-grey-100'
                                                            : 'text-white'
                                                    }`}
                                                />
                                            </div>
                                        )}
                                    </a>
                                </li>
                            ))}
                </ul>
            )}
        </div>
    );
};

export default ProductCardColors;
